import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

const Input = ({ invalid, ...props }) => (
  <input
    {...props}
    className={classNames('forms-Input', {
      [props.className]: props.className,
      'is-invalid': invalid
    })}
  />
);

Input.defaultProps = {
  className: null,
  invalid: false
};

Input.propTypes = {
  className: PropTypes.string,
  invalid: PropTypes.bool
};

export default Input;
